import { Framework } from '@/framework/instance';
import { LayerType } from '@/version-types';

export class ShortcutMenu extends Framework {
    /** 添加快捷操作菜单 */
    addMenu(layerType: LayerType, menu: string, data: React.ReactNode) {
        this.framework.operate.shortcutMenu.addCustomMenu(layerType, menu, data);
    }

    /** 移除快捷操作菜单 */
    removeMenu(layerType: LayerType, menu: string) {
        this.framework.operate.shortcutMenu.removeCustomMenu(layerType, menu);
    }

    /** 替换菜单 */
    replaceMenu(menu: React.ReactNode) {
        this.framework.operate.shortcutMenu.replaceMenu(menu);
    }

    /** 隐藏快捷操作菜单 */
    hide(isHide: boolean) {
        this.framework.operate.shortcutMenu.hide(isHide);
    }

    /** 监听快捷菜单事件 */
    onShortcutEvent(callback: (func: string) => void, weight = 0) {
        return this.framework.events.onShortcutEvent(callback, weight);
    }

    /** 触发快捷菜单事件 */
    emitShortcutEvent(func: string) {
        this.framework.events.emitShortcutEvent(func);
    }
}
